module.exports = __webpack_public_path__ + "static/media/0028_IMG_LES_MURS_PAPYRUS_W_VPA2100_VERTICALE.36e8fbbe.png";